<template> 
  <div id="home">
    <section v-if="errored">
      <b-card header-tag="header" bg-variant="light">
        <h5 slot="header">
          <strong>Canem Systems</strong>
        </h5>

        <b-alert show variant="danger">An error occurred loading data.</b-alert>
        <p>{{ error }}</p>
        <p class="text-center">
          <b-button type="button" @click="reload">Retry</b-button>
        </p>
      </b-card>
    </section>

    <section v-else>
      <div v-if="loading">
        <b-alert show class="text-center">
          Loading...
          <b-spinner></b-spinner>
        </b-alert>
      </div>

      <div v-else>
        <div v-if="hasProjects" class="text-center">
          
        </div>

        <div v-else>
          <b-card header-tag="header" bg-variant="light">
            <h5 slot="header">
               Canem WebApp 
            </h5>

            <b-alert show variant="info">No assigned projects were found for this user.</b-alert>

          </b-card>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "Home",
  components: {},

  data: function() {
    return {
      state: this.$store.state,
      data: null,
      loading: true,
      errored: false,
      error: "",
      userId: null,
      hasProjects: true,
      mru: ""
    };
  },
  mounted: function() {
    this.userId = this.$auth.userid();
    this.loading = true;
    this.fetchData();
    
  },

  activated: function() {
    this.$store.setItem("breadcrumbs", []);
    this.$store.setItem("project", "");
  },

  methods: {

    fetchData(){
      this.$auth.acquireToken().then(token => {

      Promise.all([
         this.$http
          .get("api/UserProjects", {
            headers: { Authorization: "Bearer " + token }
          }),
         this.$http
          .get("api/mru", {
            headers: { Authorization: "Bearer " + token }
          }) 
      ])

      .then (results => {
        this.data = results[0].data;
        this.mru = results[1].data;
        this.hasProjects = this.data.length > 0;
        this.errored = false;
        this.error = "";
        if(this.data.filter(e => e.projectId == this.mru).length > 0) {
          this.$router.push({ name: "Project", params: { id: this.mru }  });
          } else {
            this.$store.setItem("project","< Select project");
          };
      })

      .catch(error => {
        console.log(error);
        this.errored = true;
        this.error = error.response.statusText;
      })

      .finally(() => (this.loading = false));
       
    })

    },

    reload() {
      this.$router.go(0);
    }
  }
};
</script>

<style>
#home {
  text-align: left;
  max-width: 500px;
  margin: 0 auto;
  padding-top: 40px;
}
</style>